import DashboardLayout from '@/pages/layout/DashboardLayout.vue'
import SpacedContent from '@/pages/layout/SpacedContent.vue'
import Dashboard from '@/pages/layout/Dashboard.vue'

import Logout from '@/pages/Logout.vue'
import Login from '@/pages/Login.vue'

import Users from '@/pages/users/usersAndGroups/main'
import Accounts from '@/pages/users/accounts/main.vue'
import CardPools from '@/pages/users/cardPools/main.vue'
import Groups from '@/pages/users/groups/main.vue'
import SystemGroups from '@/pages/users/systemGroups/main.vue'
import IPGroups from '@/pages/users/ipgroups/main.vue'
import SystemUsers from '@/pages/users/systemUsers/main.vue'
import TelephoneNum from '@/pages/users/telephoneNum/main.vue'

import ServicesAndTariffsTarifficationTab from '@/pages/tariffication/servicesAndTariffs/main.vue'
import ServicesTariffication from '@/pages/tariffication/servicesAndTariffs/services/main.vue'
import ServicesTemplatesTariffication from '@/pages/tariffication/servicesAndTariffs/servicesTemplates/main.vue'
import TariffPlansTariffication from '@/pages/tariffication/servicesAndTariffs/tariffPlans/main.vue'
import ServicesInTariffsTariffication from '@/pages/tariffication/servicesAndTariffs/servicesInTariffs/main.vue'

import OtherTarifficationTab from '@/pages/tariffication/other/main.vue'
import OtherTarifficationContractType from '@/pages/tariffication/other/contractType/main.vue'
import OtherTarifficationTrafficClasses from '@/pages/tariffication/other/trafficClasses/main.vue'
import OtherTarifficationTimeRanges from '@/pages/tariffication/other/timeRanges/main.vue'
import TelephoneTarifficationTab from '@/pages/tariffication/telephone/main.vue'
import TelephoneTarifficationDirections from '@/pages/tariffication/telephone/telephoneDirections/main.vue'
import TelephoneTarifficationZones from '@/pages/tariffication/telephone/telephoneZones/main.vue'
import TarifficationAdditional from '@/pages/tariffication/additional/main.vue'
import TarifficationAdditionalAccountingPeriods from '@/pages/tariffication/additional/accountingPeriods/main.vue'
import TarifficationAdditionalChargePolicies from '@/pages/tariffication/additional/chargePolicies/main.vue'
import TarifficationAdditionalCoefficientScheme from '@/pages/tariffication/additional/coefficientScheme/main.vue'

import Banks from '@/pages/referenceBook/banks/main.vue'
import Buildings from '@/pages/referenceBook/buildings/main.vue'
import Currency from '@/pages/referenceBook/currency/main.vue'
import IPzone from '@/pages/referenceBook/IPzone/main.vue'
import Streets from '@/pages/referenceBook/streets/main.vue'
import PaymentsMethods from '@/pages/referenceBook/paymentsMethods/main.vue'
import Companies from '@/pages/referenceBook/companies/main.vue'

import ReportsOther from '@/pages/reports/other/main.vue'
import ReportsOtherBlocking from '@/pages/reports/other/blocking/main.vue'
import ReportsOtherChangeLog from '@/pages/reports/other/changeLog/main.vue'
import ReportsOtherDHCPLease from '@/pages/reports/other/dhcpLease/main.vue'
import ReportsOtherSessions from '@/pages/reports/other/sessions/main.vue'
import ReportsPayments from '@/pages/reports/payments/main.vue'
import ReportsPaymentsPayments from '@/pages/reports/payments/payments/main.vue'
import ReportsPaymentsInternalTransfer from '@/pages/reports/payments/internalTransfer/main.vue'
import ReportsPaymentsExpiringPayments from '@/pages/reports/payments/expiringPayments/main.vue'
import ReportsPaymentsOtherCharges from '@/pages/reports/payments/otherCharges/main.vue'
import ReportsPaymentsDocuments from '@/pages/reports/payments/documents/main.vue'
import ReportsServices from '@/pages/reports/services/main.vue'
import ReportsServicesGeneral from '@/pages/reports/services/general/main.vue'
import ReportsServicesServices from '@/pages/reports/services/services/main.vue'
import ReportsServicesCustomChargesReport from '@/pages/reports/services/customChargesReport/main.vue'
import ReportsServicesTraffic from '@/pages/reports/services/traffic/main.vue'
import ReportsServicesDetailedTraffic from '@/pages/reports/services/detailedTraffic/main.vue'
import ReportsServicesTelephony from '@/pages/reports/services/telephony/main.vue'
import ReportsServicesTelephonyDirectionsReport from '@/pages/reports/services/telephonyDirectionsReport/main.vue'

import InventoryProfiles from '@/pages/inventory/inventoryProfiles/main.vue'
import InventorySwitches from '@/pages/inventory/switches/main.vue'
import InventoryDhcpPools from '@/pages/inventory/dhcpPools/main.vue'
import InventoryDhcpLeases from '@/pages/inventory/dhcpLease/main.vue'

import SettingsISGTab from '@/pages/settings/ISG/main.vue'
import ISGattributes from '@/pages/settings/ISG/ISGattributes/main.vue'
import ISGprofile from '@/pages/settings/ISG/ISGprofile/main.vue'
import CustomerPortal from '@/pages/settings/customerPortal/main.vue'
import SettingsInventory from '@/pages/settings/inventory/main.vue'
import SettingsSystemTab from '@/pages/settings/system/main.vue'
import DocumentsTab from '@/pages/settings/documents/main.vue'
import Telephony from '@/pages/settings/telephony/main.vue'
import DocumentTemplates from '@/pages/settings/documents/documentTemplates/main.vue'
import ProfilesOfDocuments from '@/pages/settings/documents/profilesOfDocuments/main.vue'
import ReplacementsInDocument from '@/pages/settings/documents/replacementsInDocument/main.vue'
import EmergencyCalls from '@/pages/settings/telephony/emergencyCalls/main.vue'
import TelephoneOperators from '@/pages/settings/telephony/telephoneOperators/main.vue'
import ArchiveDB from '@/pages/settings/system/archiveDB/main.vue'
import IPpools from '@/pages/settings/system/ipPools/main.vue'
import SettingsSystem from '@/pages/settings/system/settingsSystem/main.vue'
import Additional from '@/pages/settings/system/additional/main'
import NetFlowproviders from '@/pages/settings/inventory/netFlowProviders/main.vue'
import Firewalls from '@/pages/settings/inventory/firewalls/main.vue'
import FirewallRules from '@/pages/settings/inventory/firewallRules/main.vue'
import NASlist from '@/pages/settings/inventory/NASlist/main.vue'
import radiusAccounts from '@/pages/settings/system/radiusAccounts/main.vue'
import DynamicShaping from '@/pages/settings/system/dynamicShaping/main.vue'
import TrafficCollectors from '@/pages/settings/inventory/trafficCollectors/main.vue'
import RabbitMQ from '@/pages/settings/inventory/rabbitMQ/main.vue'
import SettingsDHCPv6Tab from '@/pages/settings/DHCPv6/main.vue'
import mainDHCPv6 from '@/pages/settings/DHCPv6/mainDHCPv6/main.vue'
import ClientClassification from '@/pages/settings/DHCPv6/clientClassification/main.vue'
import Subnets from '@/pages/settings/DHCPv6/subnets/main.vue'
import SharedNetworks from '@/pages/settings/DHCPv6/sharedNetworks/main.vue'
import OptionDef from '@/pages/settings/DHCPv6/optionDef/main.vue'
import SettingsPaymentSystems from '@/pages/settings/customerPortal/paymentSystems/main.vue'
import SettingsSwitchTariff from '@/pages/settings/customerPortal/switchTariff/main.vue'
import SettingsPromisedPayments from '@/pages/settings/customerPortal/promisedPayments/main.vue'
import SettingsTransferFunds from '@/pages/settings/customerPortal/transferFunds/main.vue'
import SettingsVoluntarySuspension from '@/pages/settings/customerPortal/voluntarySuspension/main.vue'
import SettingsCustomerIndependentServiceConnect from '@/pages/settings/customerPortal/customerIndependentServiceConnect/main.vue'
import SettingsCaptivePortal from '@/pages/settings/customerPortal/captivePortal/main.vue'

const ifAuthenticated = (to, from, next) => {
  if (document.cookie.indexOf('session_id') > -1) {
    if (to.name === 'Login') {
      next('users')
      return
    }
    next()
    return
  }
  if (to.name === 'Login') {
    next()
  } else {
    next('/login')
  }
}

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/home',
    group: Users,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: '',
        name: 'SpacedContent',
        component: SpacedContent,
        beforeEnter: ifAuthenticated,
        children: [
          {
            path: 'dashboard',
            name: 'Dashboard',
            component: Dashboard,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'home',
            name: 'Home',
            component: Users,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'accounts',
            name: 'Accounts',
            component: Accounts,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'systemusers',
            name: 'SystemUsers',
            component: SystemUsers,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'groups',
            name: 'Groups',
            component: Groups,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'systemGroups',
            name: 'SystemGroups',
            component: SystemGroups,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'cardpools',
            name: 'CardPools',
            component: CardPools,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'ipgroups',
            name: 'IPGroups',
            component: IPGroups,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'telephonenum',
            name: 'TelephoneNum',
            component: TelephoneNum,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'banks',
            name: 'Banks',
            component: Banks,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'buildings',
            name: 'Buildings',
            component: Buildings,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'currency',
            name: 'Currency',
            component: Currency,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'ipZone',
            name: 'IPzone',
            component: IPzone,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'streets',
            name: 'Streets',
            component: Streets,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'paymentsMethods',
            name: 'PaymentsMethods',
            component: PaymentsMethods,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'companies',
            name: 'Companies',
            component: Companies,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'inventoryProfiles',
            name: 'InventoryProfiles',
            component: InventoryProfiles,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'inventorySwitches',
            name: 'InventorySwitches',
            component: InventorySwitches,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'InventoryDhcpPools',
            name: 'InventoryDhcpPools',
            component: InventoryDhcpPools,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'InventoryDhcpLeases',
            name: 'InventoryDhcpLeases',
            component: InventoryDhcpLeases,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'users',
            name: 'Users',
            component: Users,
            beforeEnter: ifAuthenticated
          },
          {
            path: 'ServicesAndTariffsTarifficationTab',
            name: 'ServicesAndTariffsTarifficationTab',
            component: ServicesAndTariffsTarifficationTab,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'ServicesTariffication',
                name: 'ServicesTariffication',
                component: ServicesTariffication,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ServicesTemplatesTariffication',
                name: 'ServicesTemplatesTariffication',
                component: ServicesTemplatesTariffication,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'TariffPlansTariffication',
                name: 'TariffPlansTariffication',
                component: TariffPlansTariffication,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ServicesInTariffsTariffication',
                name: 'ServicesInTariffsTariffication',
                component: ServicesInTariffsTariffication,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'TelephoneTarifficationTab',
            name: 'TelephoneTarifficationTab',
            component: TelephoneTarifficationTab,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'TelephoneTarifficationDirections',
                name: 'TelephoneTarifficationDirections',
                component: TelephoneTarifficationDirections,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'TelephoneTarifficationZones',
                name: 'TelephoneTarifficationZones',
                component: TelephoneTarifficationZones,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'OtherTarifficationTab',
            name: 'OtherTarifficationTab',
            component: OtherTarifficationTab,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'OtherTarifficationContractType',
                name: 'OtherTarifficationContractType',
                component: OtherTarifficationContractType,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'OtherTarifficationTrafficClasses',
                name: 'OtherTarifficationTrafficClasses',
                component: OtherTarifficationTrafficClasses,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'OtherTarifficationTimeRanges',
                name: 'OtherTarifficationTimeRanges',
                component: OtherTarifficationTimeRanges,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'ReportsPayments',
            name: 'ReportsPayments',
            component: ReportsPayments,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'ReportsPaymentsPayments',
                name: 'ReportsPaymentsPayments',
                component: ReportsPaymentsPayments,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsPaymentsInternalTransfer',
                name: 'ReportsPaymentsInternalTransfer',
                component: ReportsPaymentsInternalTransfer,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsPaymentsExpiringPayments',
                name: 'ReportsPaymentsExpiringPayments',
                component: ReportsPaymentsExpiringPayments,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsPaymentsOtherCharges',
                name: 'ReportsPaymentsOtherCharges',
                component: ReportsPaymentsOtherCharges,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsPaymentsDocuments',
                name: 'ReportsPaymentsDocuments',
                component: ReportsPaymentsDocuments,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'ReportsServices',
            name: 'ReportsServices',
            component: ReportsServices,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'ReportsServicesGeneral',
                name: 'ReportsServicesGeneral',
                component: ReportsServicesGeneral,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsServicesServices',
                name: 'ReportsServicesServices',
                component: ReportsServicesServices,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsServicesCustomChargesReport',
                name: 'ReportsServicesCustomChargesReport',
                component: ReportsServicesCustomChargesReport,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsServicesTraffic',
                name: 'ReportsServicesTraffic',
                component: ReportsServicesTraffic,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsServicesDetailedTraffic',
                name: 'ReportsServicesDetailedTraffic',
                component: ReportsServicesDetailedTraffic,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsServicesTelephony',
                name: 'ReportsServicesTelephony',
                component: ReportsServicesTelephony,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsServicesTelephonyDirectionsReport',
                name: 'ReportsServicesTelephonyDirectionsReport',
                component: ReportsServicesTelephonyDirectionsReport,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'ReportsOther',
            name: 'ReportsOther',
            component: ReportsOther,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'ReportsOtherBlocking',
                name: 'ReportsOtherBlocking',
                component: ReportsOtherBlocking,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsOtherChangeLog',
                name: 'ReportsOtherChangeLog',
                component: ReportsOtherChangeLog,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsOtherDHCPLease',
                name: 'ReportsOtherDHCPLease',
                component: ReportsOtherDHCPLease,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ReportsOtherSessions',
                name: 'ReportsOtherSessions',
                component: ReportsOtherSessions,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'TarifficationAdditional',
            name: 'TarifficationAdditional',
            component: TarifficationAdditional,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'TarifficationAdditionalAccountingPeriods',
                name: 'TarifficationAdditionalAccountingPeriods',
                component: TarifficationAdditionalAccountingPeriods,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'TarifficationAdditionalChargePolicies',
                name: 'TarifficationAdditionalChargePolicies',
                component: TarifficationAdditionalChargePolicies,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'TarifficationAdditionalCoefficientScheme',
                name: 'TarifficationAdditionalCoefficientScheme',
                component: TarifficationAdditionalCoefficientScheme,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'inventory',
            name: 'Inventory',
            component: SettingsInventory,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'netFlowproviders',
                name: 'NetFlowproviders',
                component: NetFlowproviders,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'trafficCollectors',
                name: 'TrafficCollectors',
                component: TrafficCollectors,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'firewalls',
                name: 'Firewalls',
                component: Firewalls,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'firewallRules',
                name: 'FirewallRules',
                component: FirewallRules,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'NASlist',
                name: 'NASlist',
                component: NASlist,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'RabbitMQ',
                name: 'RabbitMQ',
                component: RabbitMQ,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'system',
            name: 'System',
            component: SettingsSystemTab,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'SettingsSystem',
                name: 'SettingsSystem',
                component: SettingsSystem,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'additional',
                name: 'Additional',
                component: Additional,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ipPools',
                name: 'IPpools',
                component: IPpools,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'archiveDB',
                name: 'ArchiveDB',
                component: ArchiveDB,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'radiusAccounts',
                name: 'radiusAccounts',
                component: radiusAccounts,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'dynamicShaping',
                name: 'DynamicShaping',
                component: DynamicShaping,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'ISG',
            name: 'ISG',
            component: SettingsISGTab,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'ISGattributes',
                name: 'ISGattributes',
                component: ISGattributes,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'ISGprofile',
                name: 'ISGprofile',
                component: ISGprofile,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'DHCPv6',
            name: 'DHCPv6',
            component: SettingsDHCPv6Tab,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'mainDHCPv6',
                name: 'mainDHCPv6',
                component: mainDHCPv6,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'subnets',
                name: 'Subnets',
                component: Subnets,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'sharedNetworks',
                name: 'SharedNetworks',
                component: SharedNetworks,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'clientClassification',
                name: 'ClientClassification',
                component: ClientClassification,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'optionDef',
                name: 'OptionDef',
                component: OptionDef,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'telephony',
            name: 'Telephony',
            component: Telephony,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'emergencyCalls',
                name: 'EmergencyCalls',
                component: EmergencyCalls,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'telephoneOperators',
                name: 'TelephoneOperators',
                component: TelephoneOperators,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'documents',
            name: 'Documents',
            component: DocumentsTab,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'documentTemplates',
                name: 'DocumentTemplates',
                component: DocumentTemplates,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'profilesOfDocuments',
                name: 'ProfilesOfDocuments',
                component: ProfilesOfDocuments,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'replacementsInDocument',
                name: 'ReplacementsInDocument',
                component: ReplacementsInDocument,
                beforeEnter: ifAuthenticated
              }
            ]
          },
          {
            path: 'CustomerPortal',
            name: 'CustomerPortal',
            component: CustomerPortal,
            beforeEnter: ifAuthenticated,
            children: [
              {
                path: 'SettingsPaymentSystems',
                name: 'SettingsPaymentSystems',
                component: SettingsPaymentSystems,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsTransferFunds',
                name: 'SettingsTransferFunds',
                component: SettingsTransferFunds,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsSwitchTariff',
                name: 'SettingsSwitchTariff',
                component: SettingsSwitchTariff,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsPromisedPayments',
                name: 'SettingsPromisedPayments',
                component: SettingsPromisedPayments,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsVoluntarySuspension',
                name: 'SettingsVoluntarySuspension',
                component: SettingsVoluntarySuspension,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsCustomerIndependentServiceConnect',
                name: 'SettingsCustomerIndependentServiceConnect',
                component: SettingsCustomerIndependentServiceConnect,
                beforeEnter: ifAuthenticated
              },
              {
                path: 'SettingsCaptivePortal',
                name: 'SettingsCaptivePortal',
                component: SettingsCaptivePortal,
                beforeEnter: ifAuthenticated
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: ifAuthenticated
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    beforeEnter: ifAuthenticated
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js